import React, { Ref } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  Button as BootstrapButton,
  ButtonProps as BootstrapButtonProps,
} from 'react-bootstrap';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

export interface ButtonProps extends BootstrapButtonProps {
  icon?: IconProp;
  loading?: boolean;
  innerRef?: Ref<HTMLElement>;
}

const Button = ({ icon, children, loading = false, ...props }: ButtonProps) => {
  icon = loading ? faSpinnerThird : icon;

  // Remove innerRef prop to get rid of error when used inside ToolTip
  // eslint-disable-next-line no-unused-vars
  const { innerRef, ...rest } = props;

  if (!children) {
    const newClassName = props.className + ' no-child';
    props = { ...props, className: newClassName };
  }

  return (
    <BootstrapButton {...rest}>
      {icon && <FontAwesomeIcon icon={icon} spin={loading} />}
      {children}
    </BootstrapButton>
  );
};

export { BootstrapButton };

export default Button;
